/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Folder_Navigation_AriaInputs */

const en_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder navigation`)
};

const fr_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation des dossiers`)
};

const de_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordnernavigation`)
};

const it_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigazione delle cartelle`)
};

const ru_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Навигация по папкам`)
};

const es_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación por carpetas`)
};

const zh_cn2_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件夹导航`)
};

const ja_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダナビゲーション`)
};

const hi_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर नेविगेशन`)
};

const pt_pt2_explorer_nav_folder_navigation_aria = /** @type {(inputs: Explorer_Nav_Folder_Navigation_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegação por pastas`)
};

/**
* | output |
* | --- |
* | "Folder navigation" |
*
* @param {Explorer_Nav_Folder_Navigation_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_folder_navigation_aria = /** @type {((inputs?: Explorer_Nav_Folder_Navigation_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Folder_Navigation_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_folder_navigation_aria(inputs)
	if (locale === "de") return de_explorer_nav_folder_navigation_aria(inputs)
	if (locale === "it") return it_explorer_nav_folder_navigation_aria(inputs)
	if (locale === "ru") return ru_explorer_nav_folder_navigation_aria(inputs)
	if (locale === "es") return es_explorer_nav_folder_navigation_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_folder_navigation_aria(inputs)
	if (locale === "ja") return ja_explorer_nav_folder_navigation_aria(inputs)
	if (locale === "hi") return hi_explorer_nav_folder_navigation_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_folder_navigation_aria(inputs)
	return en_explorer_nav_folder_navigation_aria(inputs)
});